/** Global mission indices for the Kendrex Colony map surface (`shadowverse_kendrex.jpg`). */
export const EXPLORE_UNKNOWN_KENDREX_COLONY_FIRST_MISSION_INDEX = 41;
export const EXPLORE_UNKNOWN_KENDREX_COLONY_LAST_MISSION_INDEX = 46;
/** Cello boss — uses faction after-battle presentation with sound (missions 41–45 stay silent). */
export const EXPLORE_UNKNOWN_KENDREX_COLONY_BOSS_MISSION_INDEX = 46;
export const EXPLORE_UNKNOWN_KENDREX_COLONY_SURFACE = 'kendrex';

/**
 * @param {unknown} missionIndex
 * @returns {boolean}
 */
export function isExploreUnknownKendrexColonyMissionIndex(missionIndex) {
  const idx = Number(missionIndex);
  return (
    Number.isInteger(idx) &&
    idx >= EXPLORE_UNKNOWN_KENDREX_COLONY_FIRST_MISSION_INDEX &&
    idx <= EXPLORE_UNKNOWN_KENDREX_COLONY_LAST_MISSION_INDEX
  );
}

/**
 * @param {unknown} surface
 * @returns {boolean}
 */
export function isExploreUnknownKendrexColonySurface(surface) {
  return surface === EXPLORE_UNKNOWN_KENDREX_COLONY_SURFACE;
}

/**
 * Kendrex missions 41–45: faction after-battle art, but no music/SFX on battle-end or AfterBattle.
 * @param {unknown} missionIndex
 * @returns {boolean}
 */
export function isExploreUnknownKendrexColonySilentAfterBattleMissionIndex(missionIndex) {
  const idx = Number(missionIndex);
  return (
    isExploreUnknownKendrexColonyMissionIndex(idx) &&
    idx !== EXPLORE_UNKNOWN_KENDREX_COLONY_BOSS_MISSION_INDEX
  );
}
